/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-10-09 09:57:37
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */
import { get, post } from 'src/api/http';
import * as types from './type';
import { ReturnPageData, TaskMess } from 'src/api/types';
import { DeviceChildParams, DeviceChildData} from 'src/api/common/type';
class OnReading {
    getProtocolList (query: types.ProtocolListParams): Promise<types.ProtocolData> {
        return get('/amr/random-read/protocol-list', query);
    }
    sendProtocalByCst (data: types.SendProtocalByCstParams): Promise<types.SendProtocalByCstData<types.SendProtocalByCstList>> {
        return post('/amr/random-read/send-protocal-command-by-cst', data);
    }
    batchSendCommond (data: types.SendProtocalByCstParams): Promise<types.SendProtocalByCstData<types.BatchSendCommon>> {
        return post('/amr/random-read/batch-repeat-send-command', data);
    }
    batchRefresh (strlist:string): Promise<types.BatchRefreshData[]> {
        return post('/amr/random-read/batch-refresh', {strlist});
    }
    clearTaskStatus (strlist: string):Promise<TaskMess> {
        return post('/amr/random-read/clear-task-status', {strlist});
    }
    createReadeExcel (strlist: string):Promise<TaskMess> {
        return post('/amr/random-read/create-random-read-excel', {strlist});
    }
    sendProtocalCommand (data:types.ProtocalCommand): Promise<TaskMess> {
        return post('/amr/random-read/send-protocal-command', data);
    }
    getDeviceTreeChildNode (data: DeviceChildParams): Promise<DeviceChildData[]|null> {
        return get('/amr/random-read/device-tree-child-node', data);
    }
    getResultValue (data: types.ResultValParams): Promise<types.ResultValData> {
        return post('/amr/random-read/result-value', data);
    }
    getProtocolCommandJson (data: types.ProtocolCommandJsonParams): Promise<types.TableProcolData[]> {
        return get('/amr/random-read/protocol-command', data);
    }
    getStatusWordBitDesc (data: types.StatusWordBitDescParams): Promise<types.StatusWordBitDescList[]> {
        return get('/amr/random-read/status-word-desc', data);
    }
    getInstantProfileData (data: types.PhaseParams): Promise<types.PhaseRow[]> {
        return get('/amr/random-read/get-instant-profile-data', data);
    }
    getCommandparamDesc (commandSn: string): Promise<string[]> {
        return get('/amr/random-read/get-commandparam-desc', { commandSn });
    }
    createOndemandPlan (data: types.CreateOndemandPlan): Promise<boolean> {
        return post('/amr/random-read/create-ondemand-plan', data);
    }
    getOndemandPlan (data: types.OndemandPlanParams): Promise<ReturnPageData<types.OndemandPlanListRow>> {
        return get('/amr/random-read/get-ondemand-plan', data);
    }
    stopOndemandPlan (planSn: string): Promise<boolean> {
        return post('/amr/random-read/stop-ondemand-plan', {planSn});
    }
    startOndemandPlan (planSn: string): Promise<boolean> {
        return post('/amr/random-read/start-ondemand-plan', {planSn});
    }
    delOndemandPlan (planSn: string): Promise<boolean> {
        return post('/amr/random-read/delete-ondemand-plan', [ planSn ]);
    }
    getCreatePlanOperator (): Promise<types.PlanOperatorRows[]> {
        return get('/amr/random-read/plan-create-operator-name');
    }
    executePlan (planSn: string): Promise<boolean> {
        return post('/amr/random-read/execute-ondemand-plan', {planSn});
    }
    updatePlan (data: types.UpdatePlanParams): Promise<boolean> {
        return post('/amr/random-read/update-ondemand-plan', data);
    }
    getPLanDeviceList (data: types.QueryPlanDeviceListParams): Promise<ReturnPageData<types.QueryPlanDevcieListRow>> {
        return get('/amr/random-read/get-device-list', data);
    }
    getLeftComandList (planSn:string): Promise<types.ProtocolData> {
        return get('/amr/random-read/get-left-command-list', {planSn});
    }
    getRightComandList (planSn:string): Promise<types.ReadPlanCommandRow[]> {
        return get('/amr/random-read/get-command-list', {planSn});
    }
    saveComandList (data: types.SaveComandListParams): Promise<boolean> {
        return post('/amr/random-read/save-command-list', data);
    }
}

export default new OnReading();
